<!--
 * @Author: Hyman Choi
 * @Date: 2021-02-25 09:51:32
 * @LastEditTime: 2021-12-14 14:40:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\FileManagement\instrument\instrumentSeries.vue
-->

<template>
  <div class="container">
    <div class="main">
      <!-- 工具栏 -->
      <div class="topbar">
        <div>
          <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                    class="search-input" @keyup.enter.native="search()" clearable/>
          <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                     @click.stop="search()">
            搜索
          </el-button>
        </div>
      </div>
      <div class="topbar">

        <div class="left">
          <el-select clearable v-model="userDataTypeFilter" placeholder="全部设备分类" @change="onConditionChange">
            <el-option v-for="item in userDataTypeOptions" :value="item.value" :label="item.label"
                       :key="item.value"/>
          </el-select>
          <el-select clearable v-model="csFileConditionIDFilter" placeholder="全部产品分类" style="margin-left: 5px"
                     @change="onConditionChange">
            <el-option v-for="item in csFileConditionOptions" :value="item.fieldValue" :label="item.showName"
                       :key="item.fieldValue"/>
          </el-select>
        </div>
        <div width="100%" class="right">
          <el-button type="primary" size="small" title="Add Series" icon="el-icon-plus"
                     style="margin-right: 26px" @click="openAddSeriesDialog()">新增设备
          </el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table v-loading="loading" :header-cell-style="{ background: '#F5F7FA' }" stripe border
                :data="machineSeriesList" style="width: 100%">
        <el-table-column prop="CsFileConditionID" label="I D" align="center" width="100">
          <template slot-scope="scope">{{ scope.row.machineSeriesID }}</template>
        </el-table-column>
        <el-table-column prop="pic" label="图片" align="center">
          <template #default="scope">
            <el-image
                style="height: 40px"
                fit="scale-down"
                :src="getImageUrl(scope.row.picUrl)"
                :preview-src-list="[getImageUrl(scope.row.picUrl)]"
            >
              <template #error>
                <div>

                </div>
              </template>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="UserDataType" label="设备分类" align="center" width="100">
          <template slot-scope="scope">{{ scope.row.userDataType | userTypeTransform }}</template>
        </el-table-column>
        <el-table-column prop="UserDataType" label="产品分类" align="center" width="100">
          <template slot-scope="scope">{{ ellipsis(scope.row.csFileConditionID) }}</template>
        </el-table-column>
        <el-table-column prop="SeriesName" label="仪器序列码前6位" align="center">
          <template slot-scope="scope">{{ scope.row.seriesName }}</template>
        </el-table-column>
        <el-table-column prop="Number" label="编号" align="center">
          <template slot-scope="scope">{{ scope.row.number }}</template>
        </el-table-column>
        <el-table-column prop="Model" label="仪器型号" align="center">
          <template slot-scope="scope">{{ scope.row.model }}</template>
        </el-table-column>
        <el-table-column prop="Version" label="仪器版本号" align="center">
          <template slot-scope="scope">{{ scope.row.version }}</template>
        </el-table-column>
        <el-table-column prop="produceDesc" label="产品描述" align="center"/>
        <el-table-column label="生产日期" align="center" width="180" show-tooltip-when-overflow>
          <template slot-scope="scope">
            {{ scope.row.listingDate | formatDateTime }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="small" @click="goToEditDetail(scope.row)"></el-button>
            <el-button type="danger" size="small" title="Delete Series" icon="el-icon-delete"
                       @click="deleteSeries(scope.row)"/>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div v-show="totalCount > pageSize" class="pagination" style="margin-top: 5px;">
        <el-pagination v-show="machineSeriesList" background :page-size="pageSize"
                       :total="totalCount" :current-page="currentPage" @current-change="currentChange"/>
      </div>
      <el-select v-model="pageSize" placeholder="全部产品分类" style="margin-top: 5px;width:110px;float: right"
                 @change="onPageSizeChange">
        <el-option v-for="item in pageSizeOptions" :value="item.fieldValue" :label="item.showName"
                   :key="item.fieldValue"/>
      </el-select>
    </div>

    <!--“新增”功能对话框 -->
    <el-dialog title="新增设备" :visible.sync="addSeriesDialog" width="60%" :close-on-click-modal="false">
      <el-form :model="addSeriesForm" ref="seriesForm" :inline="true" label-position="top" v-loading="uploadLoading">
        <div v-for="(item, index) in addSeriesForm.list" :key="item.id">
          <el-form-item label="产品分类" style="width: 30%" :prop="'list.' + index + '.csFileConditionID'" required>
            <el-select v-model="addSeriesForm.list[index].csFileConditionID" style="width: 100%" placeholder="请选择">
              <el-option v-for="option in csFileConditionOptions" :key="option.fieldValue" :value="option.fieldValue"
                         :label="option.showName"/>
            </el-select>
          </el-form-item>
          <el-form-item label="设备分类" style="width: 30%" :prop="'list.' + index + '.userDataType'" required>
            <el-select v-model="addSeriesForm.list[index].userDataType" style="width: 100%"
                       placeholder="请选择">
              <el-option v-for="option in userDataTypeOptions" :key="option.value" :value="option.value"
                         :label="option.label"/>
            </el-select>
          </el-form-item>


          <el-form-item label="仪器序列码前6位" style="width: 30%" :prop="'list.' + index + '.seriesName'" :rules="[{ required: true,
                       validator: (rule, value, callback) => {
                                  if(item.seriesName===''){return callback('请补充完整')}},
                       trigger: 'blur'
                    }]">
            <el-input v-model="addSeriesForm.list[index].seriesName" placeholder="0881B2" show-word-limit
                      maxlength="6"/>
          </el-form-item>
          <el-form-item label="仪器型号" style="width: 30%" :prop="'list.' + index + '.model'" :rules="[{ required: true,
                       validator: (rule, value, callback) => {
                                  if(item.model===''){return callback('请补充完整')}},
                       trigger: 'blur'
                    }]">
            <el-input v-model="addSeriesForm.list[index].model" placeholder="Apogee 3300"/>
          </el-form-item>

          <el-form-item label="生产日期" style="width: 30%">
            <el-date-picker v-model="addSeriesForm.list[index].listingDate" type="datetime"
                            value-format="yyyy-MM-dd HH:mm"
                            placeholder="选择日期"></el-date-picker>
          </el-form-item>

          <el-form-item label="产品描述">
            <el-input type="textarea" class="produceDesc" v-model="addSeriesForm.list[index].produceDesc"/>
          </el-form-item>

          <el-form-item label="图片" style="width: 20%">
            <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                       :on-change="change2DisplayLocalImage" :auto-upload="false">
              <div style="text-align: left;">
                <el-image style="width: 100px; height: 100px"
                          :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(addSeriesForm.list[index].picUrl)"
                          fit="scale-down">
                  <template #error>
                    <p></p>
                  </template>
                </el-image>
                <br/>
                <el-button size="small" type="primary">点击上传</el-button>
              </div>

              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </div>
            </el-upload>
          </el-form-item>


          <!--          <el-form-item>-->
          <!--            <el-button size="small" type="danger" style="margin-top: 37px"-->
          <!--                       @click.stop="deleteRecord(index)">删除-->
          <!--            </el-button>-->
          <!--          </el-form-item>-->
        </div>
        <p style="line-height:2em;color: gray"><i class="el-icon-warning-outline" style="color: red"></i>设备分类用于系统解析仪器序列码、而产品分类属于客服文档管理配置，需一起完善。
        </p>
        <el-form-item>
          <!--          <el-button size="small" @click="addRecord()">+ 新增</el-button>-->
          <el-button type="primary" size="small" @click="addMachineSeries()">
            确 认
          </el-button>
          <el-button size="small" @click="addSeriesDialog = false">
            取 消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--编辑对话框-->
    <el-dialog title="编辑设备系列" :visible.sync="editSeriesDialog" width="55%" :close-on-click-modal="false">
      <el-form :model="editSeriesForm" ref="seriesForm" :inline="true" v-loading="uploadLoading"  label-position="top">
        <el-form-item label="产品分类" style="width: 30%" :rules="[{ required: true,
                       validator: (rule, value, callback) => {
                                  if(item.csFileConditionID===''){return callback('请补充完整')}},
                       trigger: 'blur'
                    }]">
          <el-select v-model="editSeriesForm.csFileConditionID" @input="change($event)" style="width: 100%"
                     placeholder="请选择">
            <el-option v-for="option in csFileConditionOptions" :key="option.fieldValue" :value="option.fieldValue"
                       :label="option.showName"/>
          </el-select>
        </el-form-item>
        <el-form-item label="设备分类" style="width: 30%" :rules="[{ required: true,
                       validator: (rule, value, callback) => {
                                  if(item.userDataType===''){return callback('请补充完整')}},
                       trigger: 'blur'
                    }]">
          <el-select v-model="editSeriesForm.userDataType" @input="change($event)" style="width: 100%"
                     placeholder="请选择">
            <el-option v-for="option in userDataTypeOptions" :key="option.value" :value="option.value"
                       :label="option.label"/>
          </el-select>
        </el-form-item>
        <el-form-item label="仪器序列码前6位" style="width: 30%" :rules="[{ required: true,
                       validator: (rule, value, callback) => {
                                  if(item.seriesName===''){return callback('请补充完整')}},
                       trigger: 'blur'
                    }]">
          <el-input v-model="editSeriesForm.seriesName" @input="change($event)" placeholder="0881B2" show-word-limit
                    maxlength="6"/>
        </el-form-item>
        <!--				<el-form-item label="编号" style="width: 15%" :rules="[{ required: true,-->
        <!--                       validator: (rule, value, callback) => {-->
        <!--                                  if(item.number===''){return callback('请补充完整')}},-->
        <!--                       trigger: 'blur'-->
        <!--                    }]">-->
        <!--					<el-input v-model="editSeriesForm.number" placeholder="088" />-->
        <!--				</el-form-item>-->
        <!--				<el-form-item label="仪器版本号" style="width: 15%" :rules="[{ required: true,-->
        <!--                       validator: (rule, value, callback) => {-->
        <!--                                  if(item.version===''){return callback('请补充完整')}},-->
        <!--                       trigger: 'blur'-->
        <!--                    }]">-->
        <!--					<el-input v-model="editSeriesForm.version" placeholder="VB.2" />-->
        <!--				</el-form-item>-->
        <el-form-item label="仪器型号" style="width: 30%" :rules="[{ required: true,
                       validator: (rule, value, callback) => {
                                  if(item.model===''){return callback('请补充完整')}},
                       trigger: 'blur'
                    }]">
          <el-input v-model="editSeriesForm.model" @input="change($event)" placeholder="Apogee 3300"/>
        </el-form-item>
        <el-form-item label="生产日期" style="width: 30%">
          <el-date-picker v-model="editSeriesForm.listingDate" type="datetime"
                          value-format="yyyy-MM-dd HH:mm"
                          placeholder="选择日期"  @input="change($event)"></el-date-picker>
        </el-form-item>

        <el-form-item label="产品描述">
          <el-input type="textarea" class="produceDesc" v-model="editSeriesForm.produceDesc" @input="change($event)"/>
        </el-form-item>

        <el-form-item label="图片" style="width: 20%">
          <el-upload ref="editUploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="editChange2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(editSeriesForm.picUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
        <p></p>
        <el-form-item style="margin-top:35px">
          <el-button type="primary" size="small" @click="editMachineSeries()">
            确 认
          </el-button>
          <el-button size="small" @click="editSeriesDialog = false">
            取 消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import {
  getMachineSeriesList,
  addMachineSeries,
  deleteMachineSeries,
  editMachineSeries,
  getConditionList, getOSSUploadInfo,
} from "@/api/system/CSDocument/file";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
import {isVaild} from "@/utils/validate";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {uploadFile2OSS} from "@/utils/OSSUpload";

export default {
  props: {
    initSearchValue: {
      type: String,
    }
  },
  data() {
    return {
      navigationKey: "instrumentSeries",

      searchValue: "",

      selectMax: {
        type: Number,
        default: 0
      },
      savePermission: true, //保存操作判断
      loading: false, // 加载开关
      totalCount: 0, // 总数
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      labelWidth: "120px", // 标签宽度
      machineSeriesList: [], // 仪器系列列表
      addSeriesDialog: false, // 添加系列对话框开关
      editSeriesDialog: false, //编辑系列对话框开关
      id: 1,
      // 添加系列表单
      addSeriesForm: {
        list: [{
          id: "",
          seriesName: "",
          userDataType: "",
          number: "",
          model: "",
          csFileConditionID: "",
        },],
      },
      editSeriesForm: {
        id: "",
        seriesName: "",
        userDataType: "",
        number: "",
        model: "",
        version: "",
        csFileConditionID: "",
      },
      userDataTypeOptions: Object.freeze([{
        value: 0,
        label: "医用"
      },
        {
          value: 1,
          label: "射线"
        },
        {
          value: 2,
          label: "IBUS"
        },
      ]),
      userDataTypeFilter: "",
      csFileConditionIDFilter: "",
      csFileConditionOptions: [],
      pageSizeOptions: [{fieldValue: 10, showName: "10条/页"}, {fieldValue: 20, showName: "20条/页"}, {
        fieldValue: 50,
        showName: "50条/页"
      }],


      uploadCoverFile: null,
      uploadCoverFileURL: "",
      uploadLoading: false
    };
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.currentPage = navigationObj.currentPage
    this.csFileConditionIDFilter = navigationObj.csFileConditionIDFilter
    this.userDataTypeFilter = navigationObj.userDataTypeFilter
    this.searchValue = navigationObj.searchValue

    if (isVaild(this.initSearchValue)) {
      this.searchValue = this.initSearchValue;
    }

    this.getMachineSeriesList();
    this.getConditionList();
  },

  methods: {
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    search() {
      this.onConditionChange();
    },

    /**
     * 页面变更
     */
    onPageSizeChange(e) {
      this.pageSize = e;
      this.currentPage = 1;
      this.getMachineSeriesList();
    },
    /**
     * 立即更新
     */
    change(e) {
      this.$forceUpdate()
    },


    /**
     * 拦截数值 遍历查找对应showName
     */
    ellipsis(value) {
      if (value !== null) {
        for (const temp of this.csFileConditionOptions) {
          if (temp.fieldValue === value.toString()) {
            return temp.showName;
          }
        }
      }
      return "";
    },

    /**
     * @description: 1.获取筛选条件列表（获取分类、属性、属性值数据结构）
     * @param {*}
     * @return {*}
     */
    getConditionList() {
      let param = {};
      getConditionList(param).then((res) => {
        this.csFileConditionOptions = res.data;
      });
    },

    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getMachineSeriesList();
    },
    /**
     * 获取所有系列
     */
    getMachineSeriesList() {

      let params = {
        // UserDataType: 0,
        sortName: "",
        sortOrder: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyWord: this.searchValue,
      };

      let where = [];
      if (isVaild(this.userDataTypeFilter)) {
        where.push({
          "field": "userDataType",
          "value": "" + this.userDataTypeFilter,
          "op": "equal",
        })
      }
      if (isVaild(this.csFileConditionIDFilter)) {
        where.push({
          "field": "csFileConditionID",
          "value": "" + this.csFileConditionIDFilter,
          "op": "equal",
        })
      }
      if (where.length > 0) {
        params.where = where
      }

      //console.log("userDataType === " + this.userDataTypeFilter + " where === " + where)
      this.loading = true;
      setNavigationItemWithObj(this.navigationKey, {
        currentPage: this.currentPage,
        userDataTypeFilter: this.userDataTypeFilter,
        csFileConditionIDFilter: this.csFileConditionIDFilter,
        searchValue: this.searchValue
      })
      getMachineSeriesList(params).then((res) => {
        this.machineSeriesList = res.data.rows;
        this.totalCount = res.data.total;
        this.utils.stopLoading(this);
      });
    },
    /**
     * 删除系列
     */
    deleteSeries(row) {
      let params = {
        machineSeriesID: row.machineSeriesID,
      };
      this.$confirm("是否要删除此系列？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            deleteMachineSeries(params).then(() => {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getMachineSeriesList();
            });
          })
          .catch(() => {
            this.$message("取消操作");
          });
    },

    /**
     * 初始化设备编辑对话框的显示内容
     */
    goToEditDetail(row) {
      this.editSeriesDialog = true;
      this.editSeriesForm.id = row.machineSeriesID;
      this.editSeriesForm.number = row.number;
      this.editSeriesForm.model = row.model.toString();
      this.editSeriesForm.version = row.version;
      this.editSeriesForm.seriesName = row.seriesName;
      this.editSeriesForm.userDataType = row.userDataType;
      this.editSeriesForm.csFileConditionID = row.csFileConditionID.toString();
      this.editSeriesForm.produceDesc = row.produceDesc
      this.editSeriesForm.picUrl = row.picUrl
      this.editSeriesForm.listingDate = row.listingDate
      this.uploadCoverFile = null;
    },

    /**
     * 打开新增设备对话框
     */
    openAddSeriesDialog() {
      this.addSeriesDialog = true;
      this.$refs.seriesForm.clearValidate();
      this.uploadCoverFile = null;
    },
    /**
     * 执行编辑操作
     */
    async editMachineSeries() {
      if (this.editSeriesForm.id === "" ||
          this.editSeriesForm.model === "" ||
          this.editSeriesForm.seriesName === "" ||
          this.editSeriesForm.userDataType === "" ||
          this.editSeriesForm.csFileConditionID === ""
      ) {
        this.$message({
          message: "信息编辑不完整，请重新确认",
          type: "warning",
        });
      } else {
        this.uploadLoading = true;
        const data = {
          csFileConditionID: this.editSeriesForm.csFileConditionID,
          machineSeriesID: this.editSeriesForm.id,
          seriesName: this.editSeriesForm.seriesName,
          model: this.editSeriesForm.model,
          userDataType: this.editSeriesForm.userDataType,
          listingDate:this.editSeriesForm.listingDate,
          produceDesc:this.editSeriesForm.produceDesc
          // number: this.editSeriesForm.number,
          // version: this.editSeriesForm.version
        };

        let savepathParamsRes = await getOSSUploadInfo({
          DataType: "34",
          ID: "0",
        });
        if (!isVaild(savepathParamsRes)) {
          this.uploadLoading = false;
          return;
        }
        let savePathParams = savepathParamsRes.resultData

        //上传封面
        if (isVaild(this.uploadCoverFile)) {
          // printObj(this.uploadCoverFile.raw)
          let timestamp = new Date().valueOf();

          let uploadRes;
          let fileName;
          if (isVaild(this.uploadCoverFile)) {
            fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
            // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
            uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
              type: this.uploadCoverFile.raw.type
            }), fileName)
          }
          if (uploadRes.status === 0) {
            data.picUrl = "/" + fileName
            // console.log(this.form.liveCover)
          } else {
            this.$message({
              type: "error",
              message: "上传失败"
            })
          }
          this.$refs.editUploadCoverRef.clearFiles();
        }
        console.log(data);
        await editMachineSeries(data).then((res) => {
          if (res.code !== 200) {
            this.$message({
              message: res.message,
              type: "warning",
            });
            this.editSeriesDialog = false;
            this.uploadLoading = false;
            this.utils.stopLoading(this);
            return;
          }
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.editSeriesDialog = false;
          this.utils.stopLoading(this);
          this.uploadLoading = false;
          this.editSeriesForm = {};
          this.getMachineSeriesList();
        });
        this.utils.stopLoading(this);
      }
    },

    /**
     * 新增/编辑前的检查功能
     */
    checkInput() {
      this.savePermission = true;
      for (var i = 0; i < this.addSeriesForm.list.length; i++) {
        console.log(this.addSeriesForm.list.length);
        console.log(this.addSeriesForm.list[i])
        if (this.addSeriesForm.list[i].userDataType === "") {
          this.$message({
            message: "请补充第" + (i + 1) + "行" + "：设备领域",
            type: "warning",
          });
          this.savePermission = false;
          break;
        } else if (!this.addSeriesForm.list[i].seriesName) {
          this.$message({
            message: "请补充第" + (i + 1) + "行" + "：仪器序列码前6位",
            type: "warning",
          });
          this.savePermission = false;
          break;
        } else if (!this.addSeriesForm.list[i].model) {
          this.$message({
            message: "请补充第" + (i + 1) + "行" + "：仪器型号",
            type: "warning",
          });
          this.savePermission = false;
          break;
        }
      }
    },

    /**
     * 新增设备
     */
    addMachineSeries() {
      this.checkInput();
      if (this.savePermission === false) {
        return;
      }
      this.uploadLoading = true;
      this.addSeriesForm.list.forEach(async (element, index) => {
        this.loading = true;
        const data = {
          csFileConditionID: element.csFileConditionID,
          seriesName: element.seriesName,
          model: element.model,
          userDataType: element.userDataType,
          number: "",
          version: "",
          produceDesc: element.produceDesc,
          listingDate: element.listingDate,
          picUrl: "",
        };

        let savepathParamsRes = await getOSSUploadInfo({
          DataType: "34",
          ID: "0",
        });
        if (!isVaild(savepathParamsRes)) {
          this.uploadLoading = false;
          return;
        }
        let savePathParams = savepathParamsRes.resultData

        //上传封面
        if (isVaild(this.uploadCoverFile)) {
          // printObj(this.uploadCoverFile.raw)
          let timestamp = new Date().valueOf();

          let uploadRes;
          let fileName;
          if (isVaild(this.uploadCoverFile)) {
            fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
            // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
            uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
              type: this.uploadCoverFile.raw.type
            }), fileName)
          }
          if (uploadRes.status === 0) {
            data.picUrl = "/" + fileName
            // console.log(this.form.liveCover)
          } else {
            this.$message({
              type: "error",
              message: "上传失败"
            })
          }
          this.$refs.uploadCoverRef[index].clearFiles();
        }

        console.log(data);
        addMachineSeries(data).then((res) => {
          if (res.code !== 200) {
            this.$message({
              message: res.message,
              type: "warning",
            });
            this.addSeriesDialog = false;
            this.uploadLoading = false;
            this.utils.stopLoading(this);
            return;
          }
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.addSeriesDialog = false;
          this.addSeriesForm.list = [{
            id: "",
            seriesName: "",
            userDataType: "",
            csFileConditionID: "",
            number: "",
            model: "",
          }];
          this.getMachineSeriesList();
          this.uploadLoading = false;
          this.utils.stopLoading(this);
        });
      });
    },

    /**
     * 删除对应仪器记录
     */
    deleteRecord(index) {
      if (this.addSeriesForm.list.length <= 1) {
        return false;
      }
      this.addSeriesForm.list.splice(index, 1);
    },
    /**
     * 增加仪器记录
     */
    addRecord() {
      if (this.addSeriesForm.list.length <= 7) {
        this.addSeriesForm.list.push({
          id: this.id++,
          userDataType: 0,
          number: "",
          model: "",
        });
      } else {
        this.$message({
          message: "批量添加不能超过8条记录",
          type: "warning",
        });
      }
    },
    /**
     * 回退上一级
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * 改变搜索条件
     */
    onConditionChange() {
      this.currentPage = 1;
      this.getMachineSeriesList();
    },

    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef[0].clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    editChange2DisplayLocalImage(uploadFile) {
      this.$refs.editUploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },

  },
};
</script>

<style scoped lang="scss">
.produceDesc {
  width: 300px;
}
</style>
